var map = {
	"./0.svg": 103,
	"./1.svg": 104,
	"./2.svg": 105,
	"./3.svg": 106,
	"./4.svg": 107,
	"./Spotify_logo_without_text.svg": 54,
	"./arrow-next.svg": 47,
	"./bandera-espa-a.svg": 31,
	"./bandera-francesa.svg": 33,
	"./bandera-inglesa.svg": 32,
	"./error-cross.svg": 34,
	"./header/logo-blanco.svg": 52,
	"./header/logo-color.svg": 108,
	"./header/logo-horizontal-blanco.svg": 53,
	"./header/logo-horizontal-color.svg": 57,
	"./iconfinder_facebook_circle_color_107175.svg": 109,
	"./iconfinder_social_media_applications_3-instagram_4102579.svg": 110,
	"./iconfinder_twitter_circle_color_107170.svg": 111,
	"./iconfinder_whatsapp_287520.svg": 112,
	"./loading-animation.svg": 113,
	"./pause.svg": 56,
	"./play.svg": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 102;